import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPedidos } from "../../reducer/actions";
import styles from "./TraePedidos.module.css";

const TraePedidos = () => {
  const dispatch = useDispatch();
  const pedidos = useSelector((state) => state.orders);

  useEffect(() => {
    dispatch(getPedidos());
  }, [dispatch]);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "¿Estás seguro de eliminar este pedido?"
    );
    if (!confirmDelete) return;

    try {
      const response = await fetch(
        `https://rezuma-back.onrender.com/Order/${id}`,
        {
          method: "DELETE",
        }
      );

      if (response.ok) {
        alert("Pedido eliminado correctamente.");
        dispatch(getPedidos()); // Refrescar la lista de pedidos después de eliminar
      } else {
        const errorData = await response.json();
        console.error("Error al eliminar pedido:", errorData);
        alert("Hubo un error al eliminar el pedido.");
      }
    } catch (error) {
      console.error("Error en la solicitud DELETE:", error);
      alert("Hubo un error al eliminar el pedido.");
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Fecha no disponible";
    const date = new Date(dateString);
    return date.toLocaleDateString("es-AR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  function capitalize(str) {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  return (
    <div className={styles.pedidosContainer}>
      <h2>Pedidos</h2>
      {pedidos && pedidos.length > 0 ? (
        [...pedidos]
          .sort((a, b) => new Date(b.kitCreatedAt) - new Date(a.kitCreatedAt))
          .map((pedido, index) => {
            const items = pedido.items || {};
            const billing = items.billingInfo || items.initialBillingInfo || {};
            const shipping =
              items.shippingInfo || items.initialShippingInfo || {};
            const kits = items.kitsCompra || [];
            const matchedKits = pedido.matchedKits || [];

            return (
              <div key={pedido.id || index} className={styles.card}>
                <div className={styles.headerPedido}>
                  <div className={styles.numeroPedido}>
                    {pedidos.length - index}
                  </div>
                  <div className={styles.fechaPedido}>
                    Creado el: {formatDate(pedido.kitCreatedAt)}
                  </div>
                </div>

                <p>
                  <strong>Nombre Completo:</strong>{" "}
                  {billing.name && billing.surname
                    ? `${capitalize(billing.name)} ${capitalize(
                        billing.surname
                      )}`
                    : "No disponible"}
                </p>

                <p>
                  <strong>Teléfono:</strong> {billing.phone || "No disponible"}
                </p>

                <p>
                  <strong>kits:</strong>
                </p>
                <ul>
                  {matchedKits.length > 0 ? (
                    matchedKits.map((kitData, kitIndex) => (
                      <li key={kitIndex}>
                        <p className={styles.kitName}>
                          {kitData.matchedKitName || "Sin nombre"}
                        </p>
                        {kitData.kit && kitData.kit.length > 0 ? (
                          kitData.kit.map((sopa, sopaIndex) => (
                            <p key={sopaIndex}>
                              {sopa?.name || "Sopa desconocida"}
                            </p>
                          ))
                        ) : (
                          <p>No hay sopas en este kit.</p>
                        )}
                      </li>
                    ))
                  ) : kits.length > 0 ? (
                    kits.map((kit, kitIndex) => (
                      <li key={kitIndex}>
                        {kit && kit.length > 0 ? (
                          kit.map((sopa, sopaIndex) => (
                            <p key={sopaIndex}>
                              {sopa?.name || "Sopa desconocida"}
                            </p>
                          ))
                        ) : (
                          <p>No hay sopas en este pedido.</p>
                        )}
                      </li>
                    ))
                  ) : (
                    <li>No hay sopas cargadas en este pedido.</li>
                  )}
                </ul>

                <p>
                  <strong>Dirección de Envío:</strong>
                </p>
                <p>
                  Calle, altura, piso/depto:{" "}
                  {shipping.street || "No disponible"}
                </p>
                <p>
                  Entre calles y barrio:{" "}
                  {shipping.crossStreetsAndNeighborhood || "No disponible"}
                </p>
                <p>Código Postal: {shipping.postalCode || "No disponible"}</p>
                <p>Email: {shipping.email || "No disponible"}</p>

                <button
                  className={styles.deleteButton}
                  onClick={() => handleDelete(pedido.id)}
                >
                  Eliminar Pedido
                </button>
              </div>
            );
          })
      ) : (
        <p>No hay pedidos disponibles.</p>
      )}
    </div>
  );
};

export default TraePedidos;
